export default __webpack_public_path__ + "static/media/bg5_m.5059c1ee.png";